/**
 * A mapping of the different currencies
 */
export default {
    "USD": {
        name: "US Dollar",
        abbr: "USD",
        pattern: ["($n)","$n"],
        decimals: 2,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "$"
    },
    "EUR": {
        name: "Euro",
        abbr: "EUR",
            pattern: ["-n $",
                "n $"],
        decimals: 2,
        ",": ".",
        ".": ",",
        groupSize: [3],
        symbol: "€"
    },
    "JPY": {
        name: "Japanese Yen",
        abbr: "JPY",
        pattern: ["-$n","$n"],
        decimals: 0,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "¥"
    },
    "GBP": {
        name: "Pound Sterling",
        abbr: "GBP",
        pattern: ["-$n","$n"],
        decimals: 2,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "£"
    },
    "CHF": {
        name: "Swiss Franc",
        abbr: "CHF",
        pattern: ["-n $","n $"],
        decimals: 2,
        ",": "'",
        ".": ".",
        groupSize: [3],
        symbol: "fr."
    },
    "CAD": {
        name: "Canadian Dollar",
        abbr: "CAD",
        pattern: ["-$n","$n"],
        decimals: 2,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "$"
    },
    "AUD": {
        name: "Australian Dollar",
        abbr: "AUD",
        pattern: ["-$n","$n"],
        decimals: 2,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "$"
    },
    "NZD": {
        name: "New Zealand Dollar",
        abbr: "NZD",
        pattern: ["-$n","$n"],
        decimals: 2,
        ",": ",",
        ".": ".",
        groupSize: [3],
        symbol: "$"
    }
}
